import React from 'react';
import { useNavigate } from 'react-router-dom';
import BulkProposerDetaills from './bulk-proposer-detaills.jsx';

const BulkProposerDetaillsPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 12 }}>
      <BulkProposerDetaills onBack={() => navigate('/documents/bulk/success')} />
    </div>
  );
};

export default BulkProposerDetaillsPage;
